import { Component, OnInit } from '@angular/core';
import { MercaderiaService } from 'src/app/service/index.service';
import { Mercaderia } from 'src/app/model/index.model';

@Component({
  selector: 'app-reporte-stock',
  templateUrl: './reporte-stock.component.html',
  styleUrls: ['./reporte-stock.component.css']
})
export class ReporteStockComponent implements OnInit {

  items: Mercaderia[];
  reporte: any[];
  fecha = new Date();
  loading: boolean = false
  constructor(private wsdl: MercaderiaService) {
    this.items = []
  }

  ngOnInit() {
    this.getList();

  }
  async getList() {
    try {
      this.loading = true
      let data = await this.wsdl.getReporteStock(null, 1, 10000).then();
      let resp = JSON.parse(JSON.stringify(data));
      console.log(resp)
      if (resp.code == 200) {
        this.items = resp.data;
        this.reporte = this.items
        console.log(this.reporte)

      }
    } catch (error) {
      console.log("error", error)

    } finally {
      this.loading = false
    }
  }

  agrupar() {
    return this.groupBy(this.items, (c) => c.grupo.nombre);
  }

  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  }

}
